// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header[data-v-6ba08fd4]{opacity:.7}.spacer[data-v-6ba08fd4]{margin-top:.2rem}.input-slot[data-v-6ba08fd4]{font-size:1rem;font-weight:700;padding-inline:1rem;border-radius:5px;border:1px solid var(--color-border);background-color:var(--background-color)}.input-slot-padding[data-v-6ba08fd4]{padding-block:.5rem}", ""]);
// Exports
module.exports = exports;
